"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.satToBtc = exports.btcToSat = exports.extractAccountAndSortNumbFromIban = exports.convertAmountByExchangeRate = exports.getCurrencySymbolFromCode = exports.invertCurrencyPair = exports.roundNumber = exports.isSupportedCurrencyPair = void 0;
let apiSupportedFiatPairs = ["EURGBP", "EURCHF"];
const isSupportedCurrencyPair = (baseCurrency, targetCurrency) => {
    let pair = baseCurrency + targetCurrency;
    return apiSupportedFiatPairs.includes(pair);
};
exports.isSupportedCurrencyPair = isSupportedCurrencyPair;
const roundNumber = (value, decimalPlaces) => {
    return Math.round(value * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
};
exports.roundNumber = roundNumber;
const invertCurrencyPair = (pair) => {
    return pair.slice(3) + pair.slice(0, 3);
};
exports.invertCurrencyPair = invertCurrencyPair;
const getCurrencySymbolFromCode = (currencyCode) => {
    if (!currencyCode) {
        return;
    }
    else if (currencyCode === "GBP") {
        return "£";
    }
    else if (currencyCode === "EUR") {
        return "€";
    }
    else if (currencyCode === "CHF") {
        return "₣";
    }
    else {
        throw new Error("UNSUPPORTED CURRENCY (getSymbolFromCode)");
    }
};
exports.getCurrencySymbolFromCode = getCurrencySymbolFromCode;
/* baseCurrency = from, targetCurrency = to */
const convertAmountByExchangeRate = (amount, exchangeRate) => __awaiter(void 0, void 0, void 0, function* () {
    if (!exchangeRate) {
        throw new Error("getExchangeRate FAILED");
    }
    let result = amount * exchangeRate;
    return result;
});
exports.convertAmountByExchangeRate = convertAmountByExchangeRate;
// bban contains account number and sort code
// "The account number can be ascertained by using the last 8 digits on the BBAN and the
// sort code can be ascertained by using the 6 digits after removing the alphanumeric
// 4 characters at the beginning of the BBAN."
const extractAccountAndSortNumbFromIban = (iban) => {
    let accountNumber = iban.slice(iban.length - 8);
    let sortCode = iban.slice(8, iban.length - 8);
    let result = { accountNumber, sortCode };
    return result;
};
exports.extractAccountAndSortNumbFromIban = extractAccountAndSortNumbFromIban;
const btcToSat = (val) => {
    return Math.round(Number(val) * 100000000);
};
exports.btcToSat = btcToSat;
const satToBtc = (val) => {
    return (Number(val) / 100000000).toFixed(8);
};
exports.satToBtc = satToBtc;
//# sourceMappingURL=moneyUtils.js.map